import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppGlobals } from '@app/app.global';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private http: HttpClient,
    private appGlobals: AppGlobals
  ) { }

  getUserProfileDetails() {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}get-user-profile`);
  }

  updateCompanyProfile(requestBody: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}update-company`, requestBody);
  }

  updateUserProfile(body) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}update-user`, body);
  }

  getBuyerMockAccountDetails() {
    return this.http.get<any>(`${this.appGlobals.apiUrl.invoice}buyer-mock-account`);
  }

  addBuyerMockAccount(body) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.invoice}add-buyer-mock-account`, body);
  }

  generateRetailPosSyncCode() {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}generate-retail-pos-sync-code`);
  }

  uploadProfileImage(imageType: string, requestBody: FormData) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}upload-profile?uploadType=${imageType}`, requestBody);
  }

  updateFeatureSettings(requestBody: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}update-feature-settings`, requestBody);
  }

  profileSetupSteps(requestBody) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}profile-setup-steps`, requestBody);
  }

  setPrimaryCompanyDetails(payload: any) {
    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}setup-primary-company-details`, payload);
  }

  getStates() {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}user-management/get-states`);
  }

  getCities(stateId: string) {
    return this.http.get<any>(`${this.appGlobals.apiUrl.authentication}user-management/get-city?state=${stateId}`);
  }
}
